<template>
  <!--列表功能模板-->
    <el-row :gutter="4" class="h100">
        <el-col :span="knowList ? 4 : 1" :class="['p_r h100i', knowList ? 'setDatads' : 'el-col-unfold']"
                v-loading="knowList && knowLoading">
            <div :class="['unfoldClassifyBtn', knowList ? 'el-icon-arrow-left':'el-icon-arrow-right']"
                 @click="knowList = !knowList"></div>
            <div class="h100 metadataTree">
                <el-radio-group size="mini" @change="getKnowModule" v-model="knowSelect" class="knowDataBtm">
                    <el-radio-button :label="1">公共知识模型</el-radio-button>
                    <el-radio-button :label="2">我的知识模型</el-radio-button>
                </el-radio-group>
                <div v-for="(item,index) in knowDataList" :key="item.id" class="itemKnow" :style="defaultTheme">
                    <div class="flex_b_c itemKnowName" @click="item.showCont = !item.showCont">
                        <div class="omit">{{ item.modelName }}</div>
                        <i :class="['btnIcon', item.showCont ? 'el-icon-arrow-up' : 'el-icon-arrow-down']"></i>
                    </div>
                    <transition name="el-zoom-in-top">
                        <div v-show="item.showCont" class="itemKnowCont">
                            <el-tree
                                    :data="item.children"
                                    :ref="'selectTree' + index"
                                    show-checkbox
                                    node-key="id" :check-strictly="true"
                                    :default-expand-all="true"
                                    @check="treeCheck(index)"
                                    :props="defaultProps">
                            </el-tree>
                        </div>
                    </transition>
                </div>
            </div>
        </el-col>
        <el-col :span="showList ? 4 : 1" :class="['p_r h100i', showList ? 'setDatads' : 'el-col-unfold']"
                v-loading="showList && treeLoading">
            <div :class="['unfoldClassifyBtn', showList ? 'el-icon-arrow-left':'el-icon-arrow-right']"
                 @click="showList = !showList"></div>
            <el-menu class="h100 metadataTree" :default-active="searchForm.basicDataId" @select="selectMenu">
                <div class="mobanTitle">元数据模板</div>
                <el-menu-item :index="item.basicDataId" v-for="item in basicDataList" :key="item.basicDataId">
                    <span slot="title">{{ item.basicDataName }}</span>
                </el-menu-item>
            </el-menu>
        </el-col>
        <el-col :span="rightEol == 0 ? 23 : rightEol == 1 ? 19 : 16" :class="['h100','el-col-unfold']">
            <div class="h100ada">
                <div class="flex_c_c">
                    <el-input class="keyWorldInput" v-model="searchForm.keyword" clearable
                              placeholder="请输入关键字" @keyup.enter.native="refreshList(1,1)"
                              @submit.native.prevent></el-input>
                    <el-button type="primary" icon="el-icon-search" class="searchBton" @click="refreshList(1,1)">搜索
                    </el-button>
                    <el-button type="primary" class="searchBton2" @click="refreshList(1,2)">结果中搜索</el-button>
                    <div class="keyWorldTip">对搜索结果不满意？试试 <span class="screen"
                                                                         @click="startSearch()">高级检索</span> 吧
                    </div>
                </div>
                <div class="flex_l_c retrievalHistory">
                    <div>全部结果</div>
                    <div v-for="(item,index) in resultRetrieval" :key="item">＞<span class="searDatas"
                                                                                    @click="returnResult(index)">“{{
                        item
                        }}”</span></div>
                </div>
                <div class="allSearchData">
                    <div class="b_b flex_b_c conditions resourceItem" v-show="conditionList.length != 0">
                        <div class="searchTitle">已选条件：</div>
                        <div ref="searchconditions"
                             :class="['flex_l_c','searchContent','subject',conditionDevelop ? 'develop' : '',conditionShow ? 'conditionsDevelop' : '']">
                            <div v-for="item in conditionList" :key="item.id"
                                 :class="['searchContentItem','subjectItem','selectStyle']">
                                {{ item.name }} <span class="el-icon-close closeConditi"
                                                      @click="deleteConditions(item)"></span>
                            </div>
                        </div>
                        <div class="developBton conditionsBton flex_l_c">
                            <div class="searchContentItem selectStyle clearts" @click="deleteConditions()">清除所选项
                            </div>
                            <div v-show="!conditionDevelop && conditionShow"
                                 @click="conditionDevelop = !conditionDevelop">展开<i
                                    class="el-icon-arrow-down"></i></div>
                            <div v-show="conditionDevelop && conditionShow"
                                 @click="conditionDevelop = !conditionDevelop">收起<i
                                    class="el-icon-arrow-up"></i></div>
                        </div>
                    </div>
                    <div class="b_b flex_b_c resourceItem">
                        <div class="searchTitle">资源标签：</div>
                        <div ref="searchTags"
                             :class="['flex_l_c','searchContent',tagsShow ? 'tagsDevelop' : '',tagsDevelop ? 'develop' : '']">
                            <div :class="['searchContentItem', conditionList.filter(itemRow=>{return itemRow.tags }).length ? '' : 'selectStyle']"
                                 @click="changeLabel('tags')">全部
                            </div>
                            <div v-for="item in resourceTags" :key="item.id" @click="changeLabel('tags',item)"
                                 :class="['searchContentItem', conditionList.filter(itemRow=>{return itemRow.id == item.id}).length ? 'selectStyle' : '']">
                                {{ item.name }}
                            </div>
                        </div>
                        <div v-if="tagsShow" class="developBton">
                            <div v-show="!tagsDevelop" @click="tagsDevelop = !tagsDevelop">展开<i
                                    class="el-icon-arrow-down"></i></div>
                            <div v-show="tagsDevelop" @click="tagsDevelop = !tagsDevelop">收起<i
                                    class="el-icon-arrow-up"></i></div>
                        </div>
                    </div>
                    <div class="b_b flex_b_c resourceItem">
                        <div class="searchTitle">资源专题：</div>
                        <div ref="searchSubject"
                             :class="['searchContent','subject','flex_l_c',subjectShow ? 'tagsDevelop' : '',subjectDevelop ? 'develop' : '']">
                            <div :class="['searchContentItem', conditionList.filter(itemRow=>{return itemRow.subject }).length ? '' : 'selectStyle']"
                                 @click="changeLabel('subject')">全部
                            </div>
                            <div v-for="item in resourceSubject" :key="item.id" @click="changeLabel('subject',item)"
                                 :class="['searchContentItem', 'subjectItem', conditionList.filter(itemRow=>{return itemRow.id == item.id}).length ? 'selectStyle' : '']">
                                {{ item.name }}
                            </div>
                        </div>
                        <div v-if="subjectShow" class="developBton">
                            <div v-show="!subjectDevelop" @click="subjectDevelop = !subjectDevelop">展开<i
                                    class="el-icon-arrow-down"></i></div>
                            <div v-show="subjectDevelop" @click="subjectDevelop = !subjectDevelop">收起<i
                                    class="el-icon-arrow-up"></i></div>
                        </div>
                    </div>
                    <div class="flex_b_c resourceItem">
                        <div class="searchTitle">资源分组：</div>
                        <div ref="searchGrouping"
                             :class="['searchContent','subject','flex_l_c', 'tagsDevelop']">
                            <div :class="['searchContentItem', conditionList.filter(itemRow=>{return itemRow.grouping }).length ? '' : 'selectStyle']"
                                 @click="changeLabel('grouping')">全部
                            </div>
                            <div v-for="item in resourceGrouping" :key="item.id" @click="changeLabel('grouping',item)"
                                 :class="['searchContentItem', 'subjectItem', conditionList.filter(itemRow=>{return itemRow.id == item.id}).length ? 'selectStyle' : '']">
                                {{ item.name }}
                            </div>
                        </div>
                        <div class="developBton">
                            <div @click="setAllGrouping()">全部</div>
                        </div>
                    </div>
                </div>
                <div class="magTop flex_b_c">
                    <div class="pageButton">
                        <el-button size="small" v-if="hasPermission('academic:resourceList:resourceList:borrow')"
                                   type="primary" @click="listSet('borrowing')">
                            <i class="iconfont icon-jieyue btnIcon"></i>
                            借阅
                        </el-button>
                        <el-button size="small" v-if="hasPermission('academic:resourceList:resourceList:borrowList')"
                                   type="primary" @click="listSet('borrowingList')">
                            <i class="iconfont icon-jiarujieyuedan btnIcon"></i>
                            加入借阅单
                        </el-button>
                        <el-button size="small" v-if="hasPermission('academic:resourceList:resourceList:collect')"
                                   :disabled="dataListSelections.filter(item=>item.isCollect != 0).length ? false : true"
                                   type="primary" @click="listSet('collect',1)">
                            <i class="iconfont icon-shoucang- btnIcon"></i>
                            收藏
                        </el-button>
                        <el-button size="small" v-if="hasPermission('academic:resourceList:resourceList:collectDel')"
                                   :disabled="dataListSelections.filter(item=>item.isCollect == 0).length ? false : true"
                                   type="primary" @click="listSet('collect',0)">
                            <i class="iconfont icon-shoucang btnIcon"></i>
                            取消收藏
                        </el-button>
                        <el-button size="small" v-if="hasPermission('academic:resourceList:resourceList:down')"
                                   type="primary" @click="downloadData()">
                            <i class="iconfont icon-xiazai btnIcon"></i>
                            下载
                        </el-button>
                    </div>
                    <div class="flex_l_c listChange" :style="defaultTheme">
                        <div :class="['iconfont', 'icon-kapianshi', 'listChangeitem', listType ? 'selectItem' : '']"
                             @click="listType = true"></div>
                        <div :class="['iconfont', 'icon-liebiaoshi', 'listChangeitem', listType ? '' : 'selectItem']"
                             @click="listType = false"></div>
                    </div>
                </div>
                <div class="contentList" v-show="!listType">
                    <el-table
                            :data="dataList"
                            size="small" height="100%"
                            class="table" ref="multipleTable" border
                            @selection-change="selectionChangeHandle" @sort-change="sortChange" row-key='id'
                            v-loading="loading">
                        <el-table-column type="selection" :reserve-selection='true' fixed/>
                        <el-table-column prop="knowledgeName" label="图片" width="130px">
                            <template slot-scope="scope">
                                <el-image
                                        style="width: 100px;height: 100px"
                                        :src="(scope.row.jsonData.suoluetu && scope.row.jsonData.suoluetu.length) ? scope.row.jsonData.suoluetu[0].netUrl : ''"
                                        fit="cover">
                                    <template slot="error" class="image-slot">
                                        <el-image
                                                style="width: 100px;height: 100px"
                                                :src="require('@/assets/img/default.png')"
                                                fit="fill">
                                        </el-image>
                                    </template>
                                </el-image>
                            </template>
                        </el-table-column>
                        <el-table-column prop="mingcheng" label="名称" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <div v-html="scope.row.jsonData.mingcheng"></div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="zhuangtai" label="状态" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <div v-html="scope.row.jsonData.zhuangtai"></div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="fenzu" label="分组" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <div v-if="scope.row.jsonData.fenzu">
                                    <span v-for="(item,index) in scope.row.jsonData.fenzu" :key="index"
                                          v-html="item"></span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="zhuanti" label="专题" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <div v-if="scope.row.jsonData.zhuanti">
                                    <span v-for="(item,index) in scope.row.jsonData.zhuanti" :key="index"
                                          v-html="item"></span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="biaoqian" label="标签" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <div v-if="scope.row.jsonData.biaoqian">
                                    <span v-for="(item,index) in scope.row.jsonData.biaoqian" :key="index"
                                          v-html="item"></span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="chuangjianshijian" label="创建时间" sortable='custom'
                                         show-overflow-tooltip>
                            <template slot-scope="scope">
                                <div>{{ scope.row.jsonData.chuangjianshijian }}</div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="chuangjianren" label="创建人" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <div v-html="scope.row.jsonData.chuangjianren"></div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="xiugairen" label="最新修改人" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <div v-html="scope.row.jsonData.xiugairen"></div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="xiugaishijian" label="最新修改时间" sortable='custom'
                                         show-overflow-tooltip>
                            <template slot-scope="scope">
                                <div>{{ scope.row.jsonData.xiugaishijian }}</div>
                            </template>
                        </el-table-column>
                        <el-table-column fixed="right" label="操作" min-width="180">
                            <template slot-scope="{row}">
                                <div style="width: 100%;display: flex;flex-wrap: wrap">
                                    <el-button type="text" size="small" @click="seeData(row)">查看</el-button>
                                    <el-button v-if="hasPermission('academic:resourceList:resourceList:borrow')"
                                               type="text" size="small" @click="borrowing(row)">借阅
                                    </el-button>
                                    <el-button v-if="hasPermission('academic:resourceList:resourceList:borrowList')"
                                               type="text" size="small" @click="borrowingList(row)">加入借阅单
                                    </el-button>
                                    <el-button v-if="hasPermission('academic:resourceList:resourceList:collect')"
                                               v-show="row.isCollect != '0'"
                                               type="text" size="small" @click="collect(row, 1)">收藏
                                    </el-button>
                                    <el-button v-if="hasPermission('academic:resourceList:resourceList:collectDel')"
                                               v-show="row.isCollect == '0'"
                                               type="text" size="small" @click="collect(row, 0)">取消收藏
                                    </el-button>
                                    <el-button v-if="hasPermission('academic:resourceList:resourceList:down')"
                                               type="text" size="small" @click="downloadData(row, 0)">下载
                                    </el-button>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="contentList" v-loading="loading" v-show="listType">
                    <el-row :gutter="10" style="width: 100%">
                        <el-col :xs="12" :sm="8" :md="8" :lg="6" :xl="4" v-for="item in dataList" :key="item.id"
                                style="margin-bottom: 10px;">
                            <div class="conteItem">
                                <el-checkbox
                                        v-model="dataListSelections.filter(itemR=> itemR.id == item.id ).length == 1"
                                        true-label="true" false-label="false"
                                        @input="pitchOnData(item)"
                                        class="itemCheckbox"></el-checkbox>
                                <el-image
                                        @click="pitchOnData(item)"
                                        class="itemImg"
                                        :src="(item.jsonData.suoluetu && item.jsonData.suoluetu.length) ? item.jsonData.suoluetu[0].netUrl : ''"
                                        fit="cover">
                                    <template slot="error" class="image-slot">
                                        <el-image
                                                @click="pitchOnData(item)"
                                                class="itemImg"
                                                :src="require('@/assets/img/default.png')"
                                                fit="fill">
                                        </el-image>
                                    </template>
                                </el-image>
                                <div class="conteItemCont" @click="seeData(item)">
                                    <el-tooltip class="item" effect="dark" :content="item.jsonData.mingcheng"
                                                placement="top">
                                        <div class="conteItemTitle omit" v-html="item.jsonData.mingcheng"></div>
                                    </el-tooltip>
                                    <div class="flex_l_t labeiw">
                                        <div class="labeiwMinItem">标签：</div>
                                        <div class="labeiwItem" v-for="(itemLabel,index) in item.jsonData.biaoqian"
                                             :key="index">
                                            <el-tooltip class="item" effect="dark" :content="itemLabel"
                                                        placement="top-start">
                                                <div v-html="itemLabel" class="omit"></div>
                                            </el-tooltip>
                                        </div>
                                    </div>
                                    <div class="text_right butonList pageButton flex_r_c" :style="defaultTheme">
                                        <!--借阅-->
                                        <div v-if="hasPermission('academic:resourceList:resourceList:borrow')"
                                             @click.stop="borrowing(item)" class="iconfont icon-jieyue btnIcon"></div>
                                        <!--加入借阅单-->
                                        <div v-if="hasPermission('academic:resourceList:resourceList:borrowList')"
                                             @click.stop="borrowingList(item)"
                                             class="iconfont icon-jiarujieyuedan btnIcon"></div>
                                        <!--收藏-->
                                        <div v-if="hasPermission('academic:resourceList:resourceList:collect')"
                                             v-show="item.isCollect != '0'" @click.stop="collect(item,1)"
                                             class="iconfont icon-shoucang btnIcon"></div>
                                        <!--取消收藏-->
                                        <div v-if="hasPermission('academic:resourceList:resourceList:collectDel')"
                                             v-show="item.isCollect == '0'" @click.stop="collect(item,0)"
                                             class="iconfont icon-shoucang- btnIcon"></div>
                                        <!--下载-->
                                        <div v-if="hasPermission('academic:resourceList:resourceList:down')"
                                             @click.stop="downloadData(item)"
                                             class="iconfont icon-xiazai btnIcon"></div>


                                        <!--                                        <el-button v-if="hasPermission('academic:resourceList:resourceList:borrow')"-->
                                        <!--                                                   size="mini" @click.stop="borrowing(item)">-->
                                        <!--                                            <i class="iconfont icon-jieyue btnIcon"></i>-->
                                        <!--                                            &lt;!&ndash;借阅&ndash;&gt;-->
                                        <!--                                        </el-button>-->
                                        <!--                                        <el-button v-if="hasPermission('academic:resourceList:resourceList:borrowList')"-->
                                        <!--                                                   size="mini" @click.stop="borrowingList(item)">-->
                                        <!--                                            <i class="iconfont icon-jiarujieyuedan btnIcon"></i>-->
                                        <!--                                            &lt;!&ndash;加入借阅单&ndash;&gt;-->
                                        <!--                                        </el-button>-->
                                        <!--                                        <el-button v-if="hasPermission('academic:resourceList:resourceList:collect')"-->
                                        <!--                                                   v-show="item.isCollect != '0'"-->
                                        <!--                                                   size="mini" @click.stop="collect(item,1)">-->
                                        <!--                                            <i class="iconfont icon-shoucang- btnIcon"></i>-->
                                        <!--                                            &lt;!&ndash;收藏&ndash;&gt;-->
                                        <!--                                        </el-button>-->
                                        <!--                                        <el-button v-if="hasPermission('academic:resourceList:resourceList:collectDel')"-->
                                        <!--                                                   v-show="item.isCollect == '0'"-->
                                        <!--                                                   size="mini" @click.stop="collect(item,0)">-->
                                        <!--                                            <i class="iconfont icon-shoucang btnIcon"></i>-->
                                        <!--                                            &lt;!&ndash;取消收藏&ndash;&gt;-->
                                        <!--                                        </el-button>-->
                                        <!--                                        <el-button v-if="hasPermission('academic:resourceList:resourceList:down')"-->
                                        <!--                                                   size="mini" @click.stop="downloadData(item)">-->
                                        <!--                                            <i class="iconfont icon-xiazai btnIcon"></i>-->
                                        <!--                                            &lt;!&ndash;下载&ndash;&gt;-->
                                        <!--                                        </el-button>-->
                                    </div>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
                <pagination :total="total" :page.sync="searchForm.current" :limit.sync="searchForm.size"
                            @pagination="refreshList"/>
            </div>
        </el-col>
        <all-grouping ref="allGrouping" @selectGrouping="selectGrouping"></all-grouping>
        <scope-hint ref="scopeHint" @reselect="reselect" @goOnBorrowing="goOnBorrowing"></scope-hint>
        <add-borrowing ref="addBorrowing" @refresh="refreshList()"></add-borrowing>
        <AdvancedSearch ref="advancedSearch" @getDataList="getSrhCondition"></AdvancedSearch>
    </el-row>
</template>

<script>
import AllGrouping from "@/views/modules/academic/resourceList/allGrouping.vue";
import ScopeHint from "@/views/modules/academic/resourceList/scopeHint.vue";
import addBorrowing from "@/views/modules/academic/resourceList/addBorrowing.vue";
import AdvancedSearch from "@/components/advancedSearch/advancedSearch.vue";

export default {
    components: {AdvancedSearch, addBorrowing, ScopeHint, AllGrouping},
    data() {
        return {
            knowLoading: false,
            knowList: true,
            knowSelect: 1,
            knowDataList: [],
            defaultProps: {
                children: 'children',
                label: 'nodeName'
            },

            treeLoading: false,
            showList: true,

            basicDataList: [], //元数据模板
            resultRetrieval: [],//结果中搜索

            conditionShow: false,//是否显示 更多、收起的按钮
            conditionDevelop: false,//是否显示 更多、收起的按钮
            conditionList: [],//已选条件

            tagsShow: false,//是否显示 更多、收起的按钮
            tagsDevelop: false,//是否展开
            resourceTags: [],//资源标签

            subjectShow: false,//是否显示 更多、收起的按钮
            subjectDevelop: false,//是否展开
            resourceSubject: [],//资源专题

            resourceGrouping: [],//分组

            listType: false,//列表状态
            searchForm: {
                keyword: '', //搜索框
                basicDataId: '',
                current: 1,
                size: 20,
                whereList: [],
                sortArchivesDataElasticsearch: [],
            },
            current2: 0,
            loading: false,
            dataList: [],
            dataListSelections: [],
            total: 0,

            advancedList: [],  // 高级查询条件

            seleListData: [], //借阅、借阅单数据
        }
    },
    mounted() {
        this.searchForm.keyword = this.$route.query.keyworld
        let resourceData = JSON.parse(sessionStorage.getItem('resourceData'))
        if (resourceData) {
            this.resultRetrieval = resourceData.resultRetrieval
            this.conditionList = resourceData.conditionList
            this.advancedList = resourceData.advancedList
            this.listType = resourceData.listType
            this.searchForm = resourceData.searchForm
            this.knowSelect = resourceData.knowSelect
            this.current2 = resourceData.searchForm.current
            this.searchForm.current = 1
            this.getField(resourceData)
        } else {
            this.getField()
        }
        this.getOtherData()
        this.getKnowModule(this.conditionList)
    },
    computed: {
        // 主题色
        defaultTheme() {
            return {
                "--color": this.$store.state.config.defaultTheme
            };
        },

        //设置 收缩
        rightEol() {
            let showData = 0
            if (this.showList) {
                showData++
            }
            if (this.knowList) {
                showData++
            }
            return showData
        },
    },
    methods: {
        // 获取元数据模板
        getField(resourceData) {
            this.treeLoading = true
            this.$axios(this.api.metadata.selectTemplateByStatus, {}, 'post').then(data => {
                this.treeLoading = false
                if (data.status) {
                    this.basicDataList = data.data
                    this.selectMenu(this.basicDataList[0].basicDataId, resourceData, 1)
                } else {
                    this.$message.error('查询失败')
                }
            })
        },

        // 选择树节点
        selectMenu(val, resourceData, type) {
            if (type == 1) {
                if (!resourceData) {
                    this.searchForm.basicDataId = val
                }
                this.refreshList()
            } else {
                this.searchForm.basicDataId = val
                this.reset()
            }
        },

        // 获取数据列表 current: 1第一页；searchType：2结果中查询，3高级查询
        refreshList(current, searchType, clearSelect) {
            if (current == 1) {
                this.searchForm.current = 1
            }
            this.loading = true
            if (searchType == 2) {
                if (this.searchForm.keyword !== '') {
                    if (this.resultRetrieval[this.resultRetrieval.length - 1] != this.searchForm.keyword) {
                        this.resultRetrieval.push(this.searchForm.keyword)
                    }
                }
            }
            if (searchType == 1) {
                this.resultRetrieval = []
            }
            if (clearSelect) {
                this.$refs.multipleTable.clearSelection()
            }
            let whereList = JSON.parse(JSON.stringify(this.searchForm.whereList))
            whereList.push(
                {
                    value: "已发布",
                    method: "and",
                    key: "zhuangtai",
                    basicTypeMethodCode: "%",
                    assemblyType: "text"
                },
                {
                    value: "学术研究子系统",
                    method: "and",
                    key: "fabuqudao",
                    basicTypeMethodCode: "%",
                    assemblyType: "text"
                }
            )
            this.conditionList.forEach(item => {
                if (item.tags) { //标签
                    whereList.push({
                        value: item.name,
                        method: 'and',
                        key: 'biaoqian',
                        basicTypeMethodCode: '%',
                        assemblyType: 'text'
                    })
                }
                if (item.subject) {  //专题
                    whereList.push({
                        value: item.name,
                        method: 'and',
                        key: 'zhuanti',
                        basicTypeMethodCode: '%',
                        assemblyType: 'text'
                    })
                }
                if (item.grouping) {  //分组
                    whereList.push({
                        value: item.name,
                        method: 'and',
                        key: 'fenzu',
                        basicTypeMethodCode: '%',
                        assemblyType: 'text'
                    })
                }
            })
            whereList.push({
                value: '开',
                method: 'and',
                key: 'shifouxianshitzngusilcu',
                basicTypeMethodCode: '%',
                assemblyType: 'text'
            })
            let keyword
            if (this.resultRetrieval.length) {
                keyword = this.resultRetrieval
            } else if (this.searchForm.keyword === '0' || this.searchForm.keyword) {
                keyword = [this.searchForm.keyword]
            } else {
                keyword = ''
            }
            let selectTreeD = []
            this.conditionList.forEach(item => {
                if (item.selectData == 0 || item.selectData) {
                    selectTreeD.push(item.nodeName)
                }
            })
            if (keyword.length == 0) {
                keyword = selectTreeD
            } else {
                keyword.push(...selectTreeD)
            }

            let highlightFields = ['suoluetu', 'mingcheng', 'zhuangtai', 'fenzu', 'zhuanti', 'biaoqian', 'chuangjianren', 'xiugairen']
            this.$axios(this.api.metadata.queryElasticsearchTemplatePageHome, {
                ...this.searchForm,
                current: this.current2 ? this.current2 : this.searchForm.current,
                keyword,
                whereList,
                highlightFields,
            }, 'post').then(data => {
                if (data.status) {
                    this.dataList = data.data.records
                    // this.dataList.forEach(item => {
                    //     if (item.jsonData.biaoqian) {
                    //         item.jsonData.biaoqian = item.jsonData.biaoqian.map(item2 => {
                    //             let dataItem = {
                    //                 name: item2,
                    //             }
                    //             if (item2.length > 8) {
                    //                 this.$set(dataItem, 'newName', item2.slice(0, 8) + '...')
                    //             }
                    //             return dataItem
                    //         })
                    //     }
                    // })
                    let resourceData = JSON.parse(sessionStorage.getItem('resourceData'))
                    if (resourceData) {
                        this.searchForm.current = resourceData.searchForm.current
                        this.current2 = 0
                        sessionStorage.removeItem('resourceData')
                    }
                    if (this.dataList.length == 0 && this.searchForm.current > 1) {
                        this.searchForm.current--
                        this.refreshList()
                    }
                    this.total = parseInt(data.data.total)
                    this.loading = false
                } else {
                    this.$message.error('查询失败');
                }
            })
        },

        // 重置
        reset() {
            this.searchForm.keyword = ''
            this.advancedList = []
            this.searchForm.whereList = []
            this.resultRetrieval = []
            this.searchForm.sortArchivesDataElasticsearch = []
            this.$nextTick(() => {
                this.refreshList(1, 3)
            })
        },

        returnResult(index) {
            this.resultRetrieval = this.resultRetrieval.splice(0, index + 1)
            this.refreshList(1, 2)
        },

        //删除已选条件
        deleteConditions(row) {
            if (row) {
                this.conditionList = this.conditionList.filter(item => {
                    if (item.id == row.id && (item.selectData || item.selectData == 0)) {
                        this.$refs['selectTree' + item.selectData][0].setChecked(item.id, false)
                    }
                    return item.id != row.id
                })
            } else {
                this.conditionList = []
                this.knowDataList.forEach((item, index) => {
                    this.$refs['selectTree' + index][0].setCheckedKeys([])
                })
            }
            this.conditionShow = false
            this.$nextTick(() => {
                this.overflowDom('searchconditions', 'conditionShow')
                this.refreshList(1, 2)
            })
        },

        //选择标签
        changeLabel(type, row) {
            if (row) {
                let reapet = this.conditionList.filter(item => {
                    return item.id == row.id
                })
                if (!reapet.length) {
                    this.conditionList.push(row)
                } else {
                    this.conditionList = this.conditionList.filter(item => {
                        return item.id != row.id
                    })
                }
            } else {
                this.conditionList = this.conditionList.filter(item => {
                    return !item[type]
                })
            }
            this.conditionShow = false
            this.$nextTick(() => {
                this.overflowDom('searchconditions', 'conditionShow')
                this.refreshList(1, 2)
            })
        },

        //获取知识模型
        getKnowModule(oldSelectData) {
            this.knowLoading = true
            if (!oldSelectData.length) {
                this.conditionList = this.conditionList.filter(item => !item.hasOwnProperty('selectData'))
            }
            if (this.knowSelect == 2) {
                this.$axios(this.api.academic.knowledgemodelQueryList, {}).then(data => {
                    if (data.status) {
                        this.knowLoading = false
                        this.knowDataList = data.data
                        this.setKnowData(oldSelectData)
                    }
                })
            } else {
                this.$axios(this.api.academic.knowledgemodelQueryPublicList, {}).then(data => {
                    if (data.status) {
                        this.knowLoading = false
                        this.knowDataList = data.data
                        this.setKnowData(oldSelectData)
                    }
                })
            }
        },

        setKnowData(oldSelectData) {
            this.knowDataList.forEach(item => {
                this.$set(item, 'showCont', true)
            })
            if (oldSelectData.length) {
                this.$nextTick(() => {
                    oldSelectData.forEach(item => {
                        if (item.selectData || item.selectData == 0) {
                            this.$refs['selectTree' + item.selectData][0].setChecked(item.id, true)
                        }
                    })
                })
            }
        },

        //获取其它信息
        getOtherData() {
            //获取标注
            this.$axios(this.api.academic.categoricalindexQueryList, {type: 0}).then(data => {
                if (data.status) {
                    this.resourceTags = data.data
                    this.resourceTags.forEach(item => {
                        this.$set(item, 'tags', true)
                        this.$set(item, 'name', item.indexName)
                    })
                    this.$nextTick(() => {
                        this.overflowDom('searchTags', 'tagsShow')
                    })
                }
            })
            //获取专题
            this.$axios(this.api.academic.categoricalindexQueryList, {type: 2}).then(data => {
                if (data.status) {
                    this.resourceSubject = data.data
                    this.resourceSubject.forEach(item => {
                        this.$set(item, 'subject', true)
                        this.$set(item, 'name', item.indexName)
                    })
                    this.$nextTick(() => {
                        this.overflowDom('searchSubject', 'subjectShow')
                    })
                }
            })
            //获取分组
            this.$axios(this.api.academic.categoricalindexQueryList, {type: 1}).then(data => {
                if (data.status) {
                    let dataList = data.data
                    dataList.forEach(item => {
                        this.$set(item, 'grouping', true)
                        this.$set(item, 'name', item.indexName)
                    })
                    this.resourceGrouping = this.arrayToTree(dataList)
                }
            })
        },
        arrayToTree(items) {
            const rootItems = [];
            const lookup = {};

            for (const item of items) {
                const itemId = item.id;
                const parentId = item.parentId;

                if (!lookup[itemId]) lookup[itemId] = {['children']: []};
                lookup[itemId] = {...item, children: lookup[itemId]['children']};

                const parent = parentId ? lookup[parentId] : null;
                if (parent) {
                    if (!parent.children) parent.children = [];
                    parent.children.push(lookup[itemId]);
                } else {
                    rootItems.push(lookup[itemId]);
                }
            }

            return rootItems;
        },
        //判断标签、专题、分组是否超过一行
        overflowDom(domName, setKeyName) {
            let configName = this.$refs[domName]
            if (setKeyName == 'conditionShow') {
                if (configName.scrollHeight > (configName.clientHeight + 12)) {
                    this[setKeyName] = true
                } else {
                    if (configName.scrollHeight == 63) {
                        this[setKeyName] = false
                    } else {
                        this[setKeyName] = true
                    }
                }
            } else {
                if (configName.scrollHeight > (configName.clientHeight + 12)) {
                    this[setKeyName] = true
                } else {
                    this[setKeyName] = false
                }
            }
        },

        //查看全部分组
        setAllGrouping() {
            this.$refs.allGrouping.init(this.resourceGrouping, this.conditionList)
        },

        //弹窗选择分组
        selectGrouping(selectList) {
            let groupingList = this.conditionList.filter(item => {
                return item.grouping
            })
            let noReapet = selectList.filter(item1 =>
                groupingList.findIndex(item2 => item2.id === item1.id) === -1
            );
            let deleteData = groupingList.filter(item1 =>
                selectList.findIndex(item2 => item2.id === item1.id) === -1
            );
            this.conditionList = this.conditionList.filter(item1 =>
                deleteData.findIndex(item2 => item2.id === item1.id) === -1
            );
            this.conditionList.push(...noReapet)
            this.refreshList(1, 2)
        },

        // 多选
        selectionChangeHandle(val) {
            this.dataListSelections = val
        },

        //多选切换选中
        pitchOnData(row) {
            let reapet = this.dataListSelections.filter(item => item.id == row.id)
            if (reapet.length) {
                this.$refs.multipleTable.toggleRowSelection(row, false)
            } else {
                this.$refs.multipleTable.toggleRowSelection(row, true)
            }
        },

        // 列表操作按钮
        listSet(butName, type) {
            if (!this.dataListSelections.length) {
                this.$message.warning('请至少选择一条数据')
                return
            }
            this[butName]('', type)
        },

        //重新选择
        reselect() {
            // this.$refs.multipleTable.clearSelection()
        },

        //继续处理(筛选出不合理的数据)
        goOnBorrowing(name) {
            if (!this.seleListData.length) {
                this.$message.warning('暂无可借阅的数据')
                return
            }
            this.$refs.addBorrowing.init(this.seleListData, name)
        },

        //借阅
        borrowing(row) {
            let setList = row ? [row] : this.dataListSelections
            let resourceIds = setList.map(item => {
                return item.id
            })
            this.$axios(this.api.academic.getResourceIds, resourceIds, 'post').then(data => {
                if (data.status) {
                    if (data.data.length) {
                        // 有数据不合理
                        let errList = []
                        setList.forEach(item1 => {
                            data.data.forEach(item2 => {
                                if (item1.id == item2.resourceId) {
                                    let statueNme
                                    if (item2.state == 1) {
                                        statueNme = '借阅审核中'
                                    }
                                    if (item2.state == 2) {
                                        statueNme = '借阅中'
                                    }
                                    if (item2.state == 3) {
                                        statueNme = '开放资源'
                                    }
                                    if (item2.state == 4) {
                                        statueNme = '已在我的借阅单中'
                                    }
                                    this.$set(item1, 'statueName', statueNme)
                                    errList.push(item1)
                                }
                            })
                        })
                        this.seleListData = setList.filter(item1 =>
                            errList.findIndex(item2 => item1.id === item2.id) === -1
                        );
                        this.$refs.scopeHint.init('borrowing', errList)
                    } else {
                        // 能借阅
                        this.$refs.addBorrowing.init(setList)
                    }
                }
            })
        },

        //借阅单
        borrowingList(row) {
            let setList = row ? [row] : this.dataListSelections
            let resourceIds = setList.map(item => {
                return item.id
            })
            this.$axios(this.api.academic.getResourceIds, resourceIds, 'post').then(data => {
                if (data.status) {
                    if (data.data.length) {
                        // 有数据不合理
                        let errList = []
                        setList.forEach(item1 => {
                            data.data.forEach(item2 => {
                                if (item1.id == item2.resourceId) {
                                    let statueNme
                                    if (item2.state == 1) {
                                        statueNme = '借阅审核中'
                                    }
                                    if (item2.state == 2) {
                                        statueNme = '借阅中'
                                    }
                                    if (item2.state == 3) {
                                        statueNme = '开放资源'
                                    }
                                    if (item2.state == 4) {
                                        statueNme = '已在我的借阅单中'
                                    }
                                    this.$set(item1, 'statueName', statueNme)
                                    errList.push(item1)
                                }
                            })
                        })
                        this.seleListData = setList.filter(item1 =>
                            errList.findIndex(item2 => item1.id === item2.id) === -1
                        );
                        this.$refs.scopeHint.init('', errList)
                    } else {
                        // 能借阅
                        this.$refs.addBorrowing.init(setList, 'bill')
                    }
                }
            })
        },

        // type 1收藏, 0取消收藏
        collect(row, type) {
            let setList = row ? [row] : this.dataListSelections
            let noData = []
            let dtos = setList.map(item => {
                if (item.isCollect != type) {
                    noData.push(item)
                }
                if (type == 1) {
                    return {
                        basicDataId: item.basicDataId,
                        metadataId: item.id,
                    }
                } else {
                    return item.id
                }
            })
            let modifyNum = setList.length - noData.length
            if (type == 1) {
                this.$axios(this.api.metadata.academicMyCollectionSave, dtos, 'post').then(data => {
                    if (data && data.status) {
                        if (row) {
                            this.$message.success('收藏成功')
                        } else {
                            this.$message.success(`已收藏${modifyNum}条资源`)
                        }
                        this.refreshList('', '', 1)
                    } else {
                        this.$message.error(data.mag)
                    }
                })
            } else {
                this.$axios(this.api.metadata.academicMyCollectionUpdateByIds, dtos, 'post').then(data => {
                    if (data && data.status) {
                        if (row) {
                            this.$message.success('取消收藏成功')
                        } else {
                            this.$message.success(`已取消收藏${modifyNum}条资源`)
                        }
                        this.refreshList('', '', 1)
                    } else {
                        this.$message.error(data.mag)
                    }
                })
            }
        },

        //下载
        downloadData(row) {
            let list = row ? [row] : this.dataListSelections
            if (!list.length) {
                this.$message.warning('请选择需要下载的数据！')
                return
            }
            let dataId = list.map(item => {
                return item.id
            })
            this.fileBlobDownload(this.api.metadata.downloadFile, {
                basicDataId: this.searchForm.basicDataId,
                configId: '',
                dataId
            }, '下载文件', 'application/zip')
        },

        //查看
        seeData(row) {
            let resourceData = {
                resultRetrieval: this.resultRetrieval,
                conditionList: this.conditionList,
                searchForm: this.searchForm,
                advancedList: this.advancedList,
                listType: this.listType,
                knowSelect: this.knowSelect,
            }
            sessionStorage.setItem('resourceData', JSON.stringify(resourceData))
            this.$router.push({
                path: '/academic/resourceList/resourcesDetails',
                query: {id: row.id, basicDataId: row.basicDataId}
            })
        },

        // 审核
        audit(row, buttonInfo) {
            let ids = []
            if (row) {
                ids = [row.id];
            } else {
                ids = this.dataListSelections.map(item => {
                    return item.id
                })
            }
            this.$refs.auditForm.init(ids, buttonInfo)
        },
        // 删除
        del(row) {
            let ids = []
            if (row) {
                ids = [row.id];
            } else {
                ids = this.dataListSelections.map(item => {
                    return item.id
                })
            }
            this.$confirm(`确定删除所选项吗?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$axios(this.api.metadata.batchDelete, ids, 'post').then(data => {
                    if (data.status) {
                        this.$message.success('删除成功')
                        this.$refs.multipleTable.clearSelection()
                        this.refreshList()
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            })
        },
        // 列表排序
        sortChange(column) {
            if (column.order) {
                this.searchForm.sortArchivesDataElasticsearch = [
                    {
                        assemblyType: 'date',
                        key: column.prop,
                        sort: column.order == "descending" ? 'desc' : (column.order == "ascending" ? 'asc' : ''),
                    }
                ]
            } else {
                this.searchForm.sortArchivesDataElasticsearch = []
            }
            this.refreshList()
        },

        startSearch() {
            this.$refs.advancedSearch.init(this.searchForm.basicDataId, this.advancedList)
        },

        // 获取高级检索条件
        getSrhCondition(data) {
            if (data) {
                this.advancedList = data.advancedList
                this.searchForm.whereList = data.whereList
                this.refreshList(1, 3)
            }
        },

        treeCheck(index) {
            let selectData = this.$refs['selectTree' + index][0].getCheckedNodes()
            selectData.forEach(item => {
                this.$set(item, 'selectData', index)
                this.$set(item, 'name', item.nodeName)
            })
            this.conditionList = this.conditionList.filter(item => item.selectData != index)
            this.conditionList.push(...selectData)
            this.$nextTick(() => {
                this.overflowDom('searchconditions', 'conditionShow')
                this.refreshList(1, 2)
            })
        },
    },
}
</script>

<style scoped lang="scss">
:root {
  --color: pink;
}

.itemKnow {
  margin: 10px 16.5px;
  white-space: nowrap;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 2px 12px 0px;

  .itemKnowName {
    border-radius: 4px 4px 0 0;
    padding: 5px 5px;
    background: var(--color);
    color: #FFFFFF;
    cursor: pointer;
  }

  .itemKnowCont {
    padding: 5px 5px;
    max-height: 150px;
    overflow: auto;
    border-radius: 0 0 4px 4px;
  }
}


.metadataTree {
  background: #ffffff;

  ::v-deep.el-menu-item {
    font-family: SourceHanSerifCN-Regular;
    font-weight: 400;
  }
}

.el-menu {
  border-right: none !important;
}

.el-menu-item, .el-submenu__title {
  height: 34px !important;
  line-height: 34px !important;
  font-size: 14px;
}

.mobanTitle {
  font-weight: 500;
  white-space: nowrap;
  font-size: 14px;
  color: #000000;
  line-height: 17px;
  font-family: SourceHanSerifCN-Medium;
  padding: 10px 0 0 16px;
}

.h100ada {
  padding: 12px;
  background: #FFFFFF;
  height: calc(100vh - 100px) !important;
  overflow-y: auto !important;

  .keyWorldInput {
    width: 40%;

    ::v-deep.el-input__inner {
      font-family: SourceHanSerifCN-Regular;
      height: 40px;
      line-height: 40px;
      font-size: 14px;
      border-radius: 8px 0px 0px 8px;
    }
  }

  .searchBton {
    font-family: SourceHanSerifCN-Regular;
    height: 40px;
    border: none;
    border-radius: 0px 8px 8px 0px;
  }

  .searchBton2 {
    font-family: SourceHanSansCN-Normal;
  }

  .keyWorldTip {
    font-family: SourceHanSansCN-Normal;
    margin-left: 15px;
    font-size: 14px;
    color: #808080;

    .screen {
      font-family: SourceHanSansCN-Medium;
      color: #C19558;
      cursor: pointer;
    }
  }

  .retrievalHistory {
    font-family: SourceHanSerifCN-Regular;
    flex-wrap: wrap;
    margin-top: 30px;
    font-size: 14px;
    color: #000000;

    .searDatas {
      font-family: SourceHanSerifCN-Medium;
      cursor: pointer;
    }
  }

  .allSearchData {
    background: #EEEEEE;
    margin-top: 20px;
    border: 1px solid #DCDCDC;

    .resourceItem {
      position: relative;
    }

    .searchTitle {
      font-family: SourceHanSerifCN-Regular;
      padding: 15px 20px;
      height: 100%;
      width: 130px;
      font-size: 14px;
      color: #000000;
    }

    .searchContent {
      padding: 13px 15px;
      font-size: 14px;
      width: 100%;
      height: 54px;
      overflow: hidden;
      flex-wrap: wrap;
      background: #F8F4EF;
    }

    .tagsDevelop {
      padding-right: 110px;
    }

    .subject {
      background: #FFFFFF;
      padding-right: 140px;
    }

    .conditionsDevelop {
      padding-right: 220px;
    }

    .develop {
      height: auto;
    }

    .developBton {
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
      margin: 13px 15px;
      text-align: center;
      background: #F8F4EF;

      div {
        padding: 2px 15px;
        font-family: SourceHanSansCN-Regular;
        font-size: 14px;
        color: #808080;
        background: #FFFFFF;
        border-radius: 4px;
        border: 1px solid #D2D2D2;

        i {
          padding-left: 5px;
        }
      }
    }

    .conditionsBton {
      background: #FFFFFF;
    }
  }
}

.searchContentItem {
  font-family: SourceHanSerifCN-Regular;
  cursor: pointer;
  margin: 5px 5px;
  padding: 1px 8px;
  border: 1px solid #F8F4EF;
}

.subjectItem {
  border-color: #FFFFFF;
}

.selectStyle {
  border-radius: 4px;
  color: #C19558;
  border-color: #C19558;
}

.conditions {
  background: #FFFFFF;

  .searchContentItem {
    cursor: default;
    padding: 2px 10px;
  }
}

.closeConditi {
  cursor: pointer;
  margin-left: 5px;
  font-size: 12px;
}

.btnIcon {
  font-size: 12px;
  padding-right: 3px;
}

.magTop {
  margin: 15px 0;
}

.listChange {
  color: var(--color);
  border: 1px solid var(--color);
  border-radius: 4px;

  .listChangeitem {
    cursor: pointer;
    padding: 3px 14px;
    font-size: 13px;
  }

  .selectItem {
    background: var(--color);
    color: #FFFFFF;
  }
}

.contentList {
  height: calc(100% - 150px);
  overflow-y: auto;
}

.conteItem {
  cursor: pointer;
  position: relative;
  box-shadow: 0px 1px 16px 0px rgba(159, 148, 132, 0.4);
  border-radius: 8px;
  border: 1px solid #EFE4D4;

  .itemCheckbox {
    position: absolute;
    left: 10px;
    top: 10px;
  }

  .itemImg {
    width: 100%;
    height: 180px;
    border-radius: 8px 8px 0px 0px;
  }

  .conteItemCont {
    font-size: 12px;
    font-family: SourceHanSansCN-Regular;
    padding: 0 10px 15px;

    .conteItemTitle {
      font-family: SourceHanSerifCN-Bold;
      font-weight: bold;
      font-size: 15px;
    }

    .labeiw {
      font-family: SourceHanSerifCN-Regular;
      margin-top: 5px;
      flex-wrap: wrap;
      height: 58px;
      overflow: hidden;

      .labeiwMinItem {
        margin-bottom: 5px;
      }

      .labeiwItem {
        margin: 0 3px 5px;
        color: #CEAE85;
        height: 24px;
        padding: 0 10px;
        line-height: 24px;
        border-radius: 12px;
        border: 1px solid #EFE4D4;
      }
    }
  }
}

.butonList {
  margin-top: 10px;

  button {
    margin-bottom: 10px;
  }

  .btnIcon {
    font-size: 18px;
    padding-left: 15px;

    &:hover {
      color: var(--color);
    }
  }

  .icon-jiarujieyuedan {
    font-size: 19px;
  }
}

.pageButton {
  button {
    font-family: SourceHanSansCN-Normal;
  }
}

.knowDataBtm {
  white-space: nowrap;
  margin: 10px 0 0 16.5px;
  //margin-left:16.5px;
  ::v-deep.el-radio-button__inner {
    font-size: 11px;
    padding: 8px 5px !important;
  }
}


.el-col-1.el-col-unfold {
  padding-left: 2.3px !important;
}

.el-col-4.setDatads {
  width: 15% !important;
}

.el-col-23.el-col-unfold {
  width: 96% !important;
}

.el-col-19.el-col-unfold {
  width: 82.8% !important;
}

.el-col-16.el-col-unfold {
  width: 70% !important;
}

.el-tree {
  min-width: 100%;
  display: inline-block !important;
}
</style>
